import styled from 'styled-components';
import { IconArrowDown, IconArrowUp, IconSort } from '../Icon/index';
var TableSortIconArrowDown = /*#__PURE__*/styled(IconArrowDown).withConfig({
  displayName: "TableSortIconArrowDown",
  componentId: "c11n-8-111-0__sc-1lrs09d-0"
})([""]);
TableSortIconArrowDown.displayName = 'TableSortIconArrowDown';
var TableSortIconArrowUp = /*#__PURE__*/styled(IconArrowUp).withConfig({
  displayName: "TableSortIconArrowUp",
  componentId: "c11n-8-111-0__sc-1lrs09d-1"
})([""]);
TableSortIconArrowUp.displayName = 'TableSortIconArrowUp';
var TableSortIconSort = /*#__PURE__*/styled(IconSort).withConfig({
  displayName: "TableSortIconSort",
  componentId: "c11n-8-111-0__sc-1lrs09d-2"
})([""]);
TableSortIconSort.displayName = 'TableSortIconSort';

/** @component */
export { TableSortIconArrowDown, TableSortIconArrowUp, TableSortIconSort };